/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeSmall1, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React, { createContext } from 'react';
import { useManageClassController } from '../../../../../hooks/controllers/manage-class-controller';
import { useModule } from '../../../../../hooks/module/module';
import { useManageClassService } from '../../../../../hooks/services/manage-class-service';
import { ContentContext } from '../../../context/content-context';
import { HeaderComponent } from '../components/manage-class/headerComponent';
import { Item } from '../components/manage-class/item';

const message = <BaSeSmall1 color="#777777">Turma desativada.</BaSeSmall1>;

const PLACEHOLDER = 'Arraste um participante.';
const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKeyLastUf = '@empretec:lastUfSelected';
const cacheKeyLastCity = '@empretec:lastCitySelected';
const cacheKeyListPaginationColumns = '@empretec:listPaginationColumns';

export const NewClassRoomContext = createContext({});

export const NewClassRoomProvider = ({ children }) => {
  const { showContentManageClass } = React.useContext(ContentContext);
  const { moduleSelected } = useModule();
  const { getcolumns } = useManageClassService();
  const { getSimpleBoardItemsData, linkInterviewToClassRoom } =
    useManageClassController();
  const { getSimpleListClass } = useManageClassService();
  const [colunas, setColunas] = React.useState([]);

  const [filters, setFilters] = React.useState({
    idClassRoom: 0,
    type: '',
    fieldOfResearch: '',
    myRecords: false,
    onlyDisableClassRoom: false,
    ufInitials: '',
    city: '',
  });

  const returnBgColor = React.useCallback(
    (active, hidePortal, backgroundColor, regional) => {
      const isRegionalActive = regional?.active;

      if (!regional || isRegionalActive) {
        if (!active) return backgroundColor;
        return hidePortal ? '#0000c4' : backgroundColor;
      }

      return '#939393';
    },
    [],
  );

  const [selectedInterestedList, setSelectedInterestedList] = React.useState(
    [],
  );
  const [interestedList, setInterestedList] = React.useState([]);

  const handleInterestedFieldFilter = React.useCallback(() => {
    if (moduleSelected?.id) {
      const id = moduleSelected?.id;

      const filter = filters.fieldOfResearch;
      getSimpleListClass(id, filter)
        .then((response) => {
          const valuesFormated = response.map((r) => {
            return {
              id: r.id,
              label: r.className,
            };
          });
          setInterestedList(valuesFormated);
        })
        .catch((error) => console.log(error));
    }
  }, [filters.fieldOfResearch, getSimpleListClass, moduleSelected]);

  const handleColumns = React.useCallback(
    (data) => {
      if (!moduleSelected) {
        return;
      }

      const id = moduleSelected.id;

      const params = {
        fieldOfResearch: data.fieldOfResearch,
        myRecords: data.myRecords,
        onlyDisableClassRoom: data.onlyDisableClassRoom,
        ufInitials: data.ufInitials,
        city: data.city,
        idClassRoom: data.idClassRoom,
      };

      if (params.idClassRoom === 0) {
        delete params.idClassRoom;
      }

      if (
        cache.hasItem('@empretec:sebrae') &&
        cache.getItem('@empretec:sebrae') !== 'NA'
      ) {
        params.ufInitials = cache.getItem('@empretec:sebrae');
      } else if (cache.hasItem(cacheKeyLastUf)) {
        params.ufInitials = cache.getItem(cacheKeyLastUf).sigla;
      }
      if (cache.hasItem(cacheKeyLastCity)) {
        params.city = cache.getItem(cacheKeyLastCity).label;
      }

      if (showContentManageClass) {
        getcolumns({ params, id }).then((response) => {
          const cols = response.map((c, index) => {
            if (index === 0) {
              return {
                id: index + 1,
                idClassRoom: c.idClassRoom,
                header: {
                  title: c.title,
                  backgroundColor: c.backgrounColor,
                  render: (items) => {
                    return (
                      <>
                        <HeaderComponent
                          regional={c.regional}
                          beginDate={c.beginDate}
                          isOwner={c.owner}
                          backgrounColor={c.backgrounColor}
                          active={c.active}
                          title={c.title}
                          endDate={c.endDate}
                          items={items}
                          hasActionItem={c.hasActionItem}
                          idClassRoom={c.idClassRoom}
                          type={c.type}
                        />
                      </>
                    );
                  },
                },
                backgroundColor: BaSeTheme.colors.institucionais.azulSebrae90,
                params: {
                  type: c.type,
                  pageIndex: 0,
                  pageSize: 10,
                  active: c.active,
                },
                items: [],
                textWithoutItems: PLACEHOLDER,
              };
            }

            if (index === 1) {
              if (
                selectedInterestedList.length === 0 ||
                selectedInterestedList.id !== c.idClassRoom
              ) {
                setSelectedInterestedList([c.idClassRoom]);
              }
              return {
                id: index + 1,
                idClassRoom: c.idClassRoom,
                header: {
                  subTitle: params.fieldOfResearch ? '' : c.subtitle,
                  title: c.title,
                  backgroundColor: c.backgrounColor,
                },
                backgroundColor: BaSeTheme.colors.institucionais.azulSebrae90,
                params: {
                  type: c.type,
                  pageIndex: 0,
                  pageSize: 10,
                  active: c.active,
                },
                items: [],
                textWithoutItems: PLACEHOLDER,
              };
            }

            return {
              id: index + 1,
              idClassRoom: c.idClassRoom,

              header: {
                title: c.title,
                subTitle: c.subtitle,
                backgroundColor: returnBgColor(
                  c.active,
                  c.hidePortal,
                  c.backgrounColor,
                  c.regional,
                ),
                hasCompression: true,
                render: (items) => {
                  return (
                    <>
                      <HeaderComponent
                        regional={c.regional}
                        hidePortal={c.hidePortal}
                        backgrounColor={c.backgrounColor}
                        beginDate={c.beginDate}
                        isOwner={c.owner}
                        title={c.title}
                        active={c.active}
                        endDate={c.endDate}
                        items={items}
                        hasActionItem={c.hasActionItem}
                        idClassRoom={c.idClassRoom}
                        type={c.type}
                        seminarValue={c.seminarValue}
                      />
                    </>
                  );
                },
              },
              params: {
                type: c.type,
                pageIndex: 0,
                pageSize: 10,
                active: c.active,
                hidePortal: c.hidePortal,
                color: returnBgColor(
                  c.active,
                  c.hidePortal,
                  c.backgrounColor,
                  c.regional,
                ),
              },

              items: [],
              textWithoutItems:
                c.regional && !c.regional.active
                  ? message
                  : c.active
                  ? PLACEHOLDER
                  : message,
            };
          });

          const listPagination = cols.map(({ params, idClassRoom, header }) => {
            return {
              params,
              idClassRoom,
              header,
            };
          });
          if (cache.hasItem(cacheKeyListPaginationColumns)) {
            cache.removeItem(cacheKeyListPaginationColumns);
          }
          cache.setItem(cacheKeyListPaginationColumns, listPagination);
          setColunas(cols);
          handleInterestedFieldFilter();
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      moduleSelected,
      showContentManageClass,
      getcolumns,
      handleInterestedFieldFilter,
    ],
  );

  React.useEffect(() => {
    if (!showContentManageClass) {
      setFilters((prev) => {
        return {
          ...prev,
          fieldOfResearch: '',
          myRecords: false,
          onlyDisableClassRoom: false,
          ufInitials: '',
          city: '',
          idClassRoom: 0,
        };
      });
      setSelectedInterestedList([]);
    }
  }, [showContentManageClass]);

  React.useEffect(() => {
    if (!showContentManageClass) return;

    handleColumns(filters);
  }, [filters, handleColumns, showContentManageClass]);

  const fetchColumnsItem = React.useCallback(
    async (event) => {
      if (!moduleSelected) {
        return;
      }

      const idModule = moduleSelected.id;

      const {
        column: { params, idClassRoom },
        type,
      } = event;
      const newFilterType = {
        ...filters,
        type: params.type,
        idClassRoom:
          params.type === 'INTERESTED' ? filters.idClassRoom : idClassRoom,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
      };

      if (
        cache.hasItem('@empretec:sebrae') &&
        cache.getItem('@empretec:sebrae') !== 'NA'
      ) {
        newFilterType.ufInitials = cache.getItem('@empretec:sebrae');
      } else if (cache.hasItem(cacheKeyLastUf)) {
        newFilterType.ufInitials = cache.getItem(cacheKeyLastUf).sigla;
      }
      if (cache.hasItem(cacheKeyLastCity)) {
        newFilterType.city = cache.getItem(cacheKeyLastCity).label;
      }

      try {
        let response;

        if (type === 'SCROLL') {
          const pagination = cache.getItem(cacheKeyListPaginationColumns);
          const columnFinded = pagination.find(
            (p) =>
              p.idClassRoom === idClassRoom && p.params.type === params.type,
          );
          if (columnFinded) {
            const newItem = {
              ...columnFinded,
              params: {
                type: params.type,
                pageIndex: columnFinded.params.pageIndex + 1,
                pageSize: 10,
              },
            };

            newFilterType.pageIndex = newItem.params.pageIndex;

            const index = pagination.findIndex(
              (item) =>
                item.idClassRoom === idClassRoom &&
                item.params.type === params.type,
            );
            if (index !== -1) {
              pagination[index] = newItem;
            }

            cache.setItem(cacheKeyListPaginationColumns, pagination);
          }
        }

        response = await getSimpleBoardItemsData({
          params: newFilterType,
          idModule,
        });
        const listItems = response.items?.map((d) => {
          return {
            id: d.idInterview,
            render: () => {
              return (
                <Item
                  name={d.name}
                  id={d.idInterview}
                  comments={d.comments ?? []}
                  active={params.active}
                  hidePortal={params.hidePortal}
                  color={params.color}
                />
              );
            },
          };
        });
        return listItems;
      } catch (error) {
        return [];
      }
    },
    [moduleSelected, filters, getSimpleBoardItemsData],
  );

  const handleValidDrop = React.useCallback(
    async (ev) => {
      if (Number(ev.columnTarget.id) === Number(ev.columnOrigin.id)) {
        return false;
      }
      const columns = colunas ?? [];

      const colunaOrigem = columns.find(
        (c) => c.id === Number(ev.columnOrigin.id),
      );

      const colunaDestino = columns.find(
        (c) => c.id === Number(ev.columnTarget.id),
      );

      const dto = {
        idClassSource: colunaOrigem.idClassRoom,
        typeSource: colunaOrigem.params.type,
        idClassTarget: colunaDestino.idClassRoom,
        typeTarget: colunaDestino.params.type,
        idInterview: +ev.item.id,
      };

      try {
        const result = await linkInterviewToClassRoom(dto);
        const responsecOLS = handleColumns(filters);
        if (responsecOLS) {
          const cols = responsecOLS.map((c, index) => {
            if (index === 0) {
              return {
                id: index + 1,
                idClassRoom: c.idClassRoom,
                header: {
                  title: c.title,
                  backgroundColor: c.backgrounColor,
                  render: (items) => {
                    return (
                      <>
                        <HeaderComponent
                          regional={c.regional}
                          beginDate={c.beginDate}
                          isOwner={c.owner}
                          backgrounColor={c.backgrounColor}
                          active={c.active}
                          title={c.title}
                          endDate={c.endDate}
                          items={items}
                          hasActionItem={c.hasActionItem}
                          idClassRoom={c.idClassRoom}
                          type={c.type}
                        />
                      </>
                    );
                  },
                },
                backgroundColor: BaSeTheme.colors.institucionais.azulSebrae90,
                params: {
                  type: c.type,
                  pageIndex: 0,
                  pageSize: 10,
                  active: c.active,
                },
                items: [],
                textWithoutItems: PLACEHOLDER,
              };
            }

            if (index === 1) {
              if (
                selectedInterestedList.length === 0 ||
                selectedInterestedList.id !== c.idClassRoom
              ) {
                setSelectedInterestedList([c.idClassRoom]);
              }
              return {
                id: index + 1,
                idClassRoom: c.idClassRoom,
                header: {
                  subTitle: c.subtitle || '',
                  title: c.title,
                  backgroundColor: c.backgrounColor,
                },
                backgroundColor: BaSeTheme.colors.institucionais.azulSebrae90,
                params: {
                  type: c.type,
                  pageIndex: 0,
                  pageSize: 10,
                  active: c.active,
                },
                items: [],
                textWithoutItems: PLACEHOLDER,
              };
            }

            return {
              id: index + 1,
              idClassRoom: c.idClassRoom,

              header: {
                title: c.title,
                subTitle: c.subtitle,
                backgroundColor: returnBgColor(
                  c.active,
                  c.hidePortal,
                  c.backgrounColor,
                  c.regional,
                ),
                hasCompression: true,
                render: (items) => {
                  return (
                    <>
                      <HeaderComponent
                        regional={c.regional}
                        backgrounColor={c.backgrounColor}
                        beginDate={c.beginDate}
                        isOwner={c.owner}
                        title={c.title}
                        active={c.active}
                        endDate={c.endDate}
                        items={items}
                        hasActionItem={c.hasActionItem}
                        idClassRoom={c.idClassRoom}
                        type={c.type}
                        seminarValue={c.seminarValue}
                      />
                    </>
                  );
                },
              },
              params: {
                type: c.type,
                pageIndex: 0,
                pageSize: 10,
                active: c.active,
              },

              items: [],
              textWithoutItems:
                c.regional && !c.regional.active
                  ? message
                  : c.active
                  ? PLACEHOLDER
                  : message,
            };
          });
          setColunas(cols);
        }
        return result;
      } catch (error) {
        console.error('Erro ao mover item:', error);
        return false;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [colunas, filters, handleColumns, linkInterviewToClassRoom],
  );

  return (
    <NewClassRoomContext.Provider
      value={{
        colunas,
        fetchColumnsItem,
        handleValidDrop,
        setFilters,
        filters,
        handleColumns,
        interestedList,
        setInterestedList,
        selectedInterestedList,
        setSelectedInterestedList,
      }}
    >
      {children}
    </NewClassRoomContext.Provider>
  );
};
